import { render, staticRenderFns } from "./LessonForm.vue?vue&type=template&id=24d7835a&"
import script from "./LessonForm.vue?vue&type=script&lang=js&"
export * from "./LessonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports